module.exports = __webpack_public_path__ + "media/images/top/place/other-place3-49a640641e7e87d10ed96d9329aef230.png";